// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"260a1d86","828":"c6a6b73c","849":"0408bfd0"}[chunkId] + ".chunk.js";
};